module.exports = __webpack_public_path__ + "img/performance_appraisal_banner.17470825.jpg";